<template>
  <div class="blog-posts-page posts">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h1 class="w-full mr-2">Add comment to: {{ post.title }}</h1>
    </div>
    <!-- <div class="pointer mr-4 border-dark" @click="setDefaultUser()">
      <strong>Marko</strong>
    </div> -->
    <div class="row mb-3">
      <div class="input-group col-md-6">
        <input
          class="form-control"
          type="email"
          v-model="newComment.email"
          placeholder="Email"
        />
      </div>
      <div class="input-group col-md-6">
        <input
          class="form-control"
          type="text"
          v-model="newComment.name"
          placeholder="Name"
        />
      </div>
    </div>

    <div class="input-group mb-3">
      <textarea
        class="form-control"
        type="text"
        v-model="newComment.content"
        placeholder="Comment"
        rows="3"
      />
    </div>

    <button
      :disabled="areFieldsEmpty"
      class="btn btn-primary d-flex ml-auto"
      @click.prevent="addComment()"
    >
      <b>Save</b>
    </button>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "NewComment",
  data: () => ({
    newComment: {
      content: "",
      commentable_id: null,
      commentable_type: "posts",
      name: "",
      email: ""
    },
    post: null
  }),
  mounted() {
    this.getPost();
  },
  computed: {
    areFieldsEmpty() {
      return (
        this.newComment.content === "" ||
        this.newComment.name === "" ||
        this.newComment.email === ""
      );
    }
  },
  methods: {
    // setDefaultUser() {
    //   this.newComment.name = "Marko Savić";
    //   this.newComment.email = "marcodentaltourism@gmail.com";
    // },
    getPost() {
      axios
        .get(`posts/${this.$route.params.postId}`)
        .then(resp => {
          this.post = resp.data.data;
        })
        .catch(err => this.errors.record(err.response.data.errors));
    },
    addComment() {
      this.newComment.commentable_id = this.$route.params.postId;
      axios
        .post("/comments", { ...this.newComment })
        .then(() => {
          this.$vToastify.success("Comment added.");
          this.newComment.content = "";
          this.newComment.name = "";
          this.newComment.email = "";
        })
        .catch(error => {
          console.log(error);
          this.$vToastify.error(error.message, "Error");
        });
    }
  }
};
</script>
<style scoped>
.expand span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tags-container {
  background-color: #fff;
  border-radius: 2px;
  margin-bottom: 10px;
  padding: 10px 30px;
}
.tags-title {
  font-weight: 600;
  font-size: 16px;
  color: #4c5669;
}
.comment {
  word-break: break-all;
}

@media (max-width: 575.98px) {
  .tags-container {
    flex-direction: column-reverse;
  }
  .header-right-side {
    flex-direction: column;
  }
  .input-group {
    margin: 8px 0;
  }
  .options-buttons {
    margin: 16px 0;
  }
}
</style>
